import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selected: {
		id: 'software.main.board-container.board.column.header.menu.item-old-done-cutoff-select.selected',
		defaultMessage: 'Selected',
		description: 'Aria label for the selected option icon',
	},
});
